import React, { Component } from 'react';
import { DataHandler } from 'C4';

export default class BackVideo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      video: null,
      image: null,
      size: null,
      ready: false,
    };
  }

  componentWillMount() {
    DataHandler.matchAppId().then((appId) =>
      this.setState({
        video: `https://front.travpromobile.com/${appId}/bgVideo.mp4`,
        image: `https://front.travpromobile.com/${appId}/bg.jpg`,
        size: {
          width: document.body.clientWidth,
          height: document.body.clientHeight,
        },
      }),
    );
  }

  render() {
    const { video, image, size, ready } = this.state;
    return (
      <video
        className='backgroundVideo'
        src={video}
        autoPlay
        muted
        loop
        preload='auto'
        poster={image}
        height={size && size.height}
        width={size && size.width}
        onLoadedData={() => {
          if (!ready) this.setState({ ready: true });
        }}
        style={{ opacity: ready ? 1 : 0 }}
      >
        <track kind='captions' />
      </video>
    );
  }
}
